import React from 'react'
import Banner from '../Compnents/Home/Banner'
import Features from '../Compnents/Home/Features'
import Testimonials from '../Compnents/Home/Testimonials'
import NewsLetter from '../Compnents/Home/NewsLetter'
import CategoryTable from '../Compnents/Home/CategoryTable'
import StepBanner from '../Compnents/Home/StepBanner'
import LastBanner from '../Compnents/Home/LastBanner'

const Home = () => {
    return (
        <>
            <Banner />
            <StepBanner />
            <CategoryTable />
            <Features />
            <LastBanner />
            {/* <Testimonials /> */}
            {/* <NewsLetter /> */}
        </>
    )
}

export default Home